import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeroImageComponent } from '../../../shared/components/hero-image/hero-image.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { PartnersSalonsComponent } from '../../shared/components/partners-salons/partners-salons.component';

@Component({
    selector: 'app-salons',
    templateUrl: './salons.component.html',
    styleUrls: ['./salons.component.scss'],
    imports: [HeroImageComponent, TitleComponent, PartnersSalonsComponent],
})
export class SalonsComponent {
    readonly voivodeship = <string>inject(ActivatedRoute).snapshot.paramMap.get('voivodeship');
}
